export const breakpoints = {
  mobileLarge: '375px',
  tablet: '640px',
  desktop: '976px',
  desktopLarge: '1140px',
  desktopXLarge: '1440px',
};

type BreakpointKeys = keyof typeof breakpoints;

type BreakPointRecord = Record<
  BreakpointKeys | `${BreakpointKeys}Query`,
  string
>;

// eslint-disable-next-line no-restricted-exports
export const screen = Object.entries(breakpoints).reduce(
  (acc, [breakpoint, value]) => {
    const str = `(min-width: ${value})`;

    return {
      ...acc,
      [`${breakpoint}Query`]: str,
      [`${breakpoint}`]: `@media${str}`,
    };
  },
  {} as BreakPointRecord,
);
